export default "__VITE_ASSET__BoGjTkW4__"